<mat-sidenav-container class="sidenav-container" *ngIf="languageSet$ | async">
  <mat-sidenav #drawer class="sidenav-primary" fixedInViewport="true"  mode="side" opened="true" position="start">
    <cz-sidenav-primary [isAdminsite]="isAdminsite" [navItems$]="primaryNavItems$" [isDefaultUser]="isDefaultUser"></cz-sidenav-primary>
    <cz-sidenav-secondary [navItems$]="secondaryNavItems$" [user$]="loggedInUser$"></cz-sidenav-secondary>
  </mat-sidenav>

  <mat-sidenav-content>
    <cz-header 
      [user$]="loggedInUser$"
      [isDefaultUser]="isDefaultUser"></cz-header>
    <main class="page-view-content container-fluid">
      <router-outlet></router-outlet>
    </main>
    <cz-footer [surveyProgress]="surveyProgress$ | async"></cz-footer>
  </mat-sidenav-content>
</mat-sidenav-container>
